const titleRules = [
  {
    when: ({ isUseBinCaidCodes }) => isUseBinCaidCodes,
    value: "Add BIN and CAID codes"
  },
  {
    when: ({ isActiveRDR, subStep }) => isActiveRDR && subStep === 2,
    value: "Add Visa ARN codes"
  },
  {
    when: ({ subStep }) => subStep === 1,
    value: "Add billing descriptor"
  }
]

export const getTitle = ({ isUseBinCaidCodes, isActiveRDR, subStep, t }) => {
  const rule = titleRules.find((r) => r.when({ isUseBinCaidCodes, isActiveRDR, subStep }))
  if (!rule) return ""
  return t(rule?.value)
}
